<template>
  <div class="info">
    <div class="main-container">
      <div class="main-content">
        <div class="main-title heading-3-bold" v-html="field.value.title"></div>
        <div class="info-column-wrapper">
          <div class="info-column">
            <div class="subtitle paragraph-1" v-html="field.value.text"></div>
            <seu-button
              :label="field.value.buttonLabel"
              :button-icon-before="field.value.buttonIcon"
              button-link="https://www.google.com/maps?q=47.20113,8.78043"
              target="_blank"
            />
          </div>
          <div class="info-column right-column">
            <div class="links-container">
              <a href="https://www.google.com/maps/place/Churerstrasse+54,+8808+Pf%C3%A4ffikon,+Switzerland/@47.2012196,8.7782759,17z/data=!3m1!4b1!4m6!3m5!1s0x479ab14d5cbde19f:0x9fe764032bac78e7!8m2!3d47.2012196!4d8.7804646!16s%2Fg%2F11c5k_0qw3" class="info-row">
                <div class="icon-container">
                  <img class="info-asset" :src="field.value.icon1" alt="">
                </div>
                <div class="paragraph-1" v-html="field.value.location"></div>
              </a>
              <a href="tel:+41 (0)58 521 19 00" class="info-row">
                <div class="icon-container">
                  <img class="info-asset" :src="field.value.icon2" alt="">
                </div>
                <div class="paragraph-1" v-html="field.value.number"></div>
              </a>
              <a href="https://www.seu.ch" target="_blank" class="info-row">
                <div class="icon-container">
                  <img class="info-asset" :src="field.value.icon3" alt="">
                </div>
                <a class="paragraph-1" v-html="field.value.website"></a>
              </a>
              <a href="mailto:info@seu.ch" class="info-row">
                <div class="icon-container">
                  <img class="info-asset" :src="field.value.icon4" alt="">
                </div>
                <a class="paragraph-1" v-html="field.value.email"></a>
              </a>
              <a href="https://www.linkedin.com/company/swiss-engineers-united" class="info-row">
                <div class="icon-container">
                  <img class="info-asset" :src="field.value.icon5" alt="">
                </div>
                <span class="paragraph-1" v-html="field.value.linkedin"></span>
              </a>
            </div>
            <seu-button
              class="button-secondary"
              :label="field.value.buttonLabel2"
              :button-icon-before="field.value.buttonIcon2"
              @click="$emit('openPopup', 'ARRIVAL')"
              target="_blank"
            />
          </div>
        </div>
      </div>
      <div class="logo-wrapper">
        <div class="logo-box" v-scroll-animate>
          <div class="logo-container">
            <div class="asset-container">
              <img src="./../../assets/logo/seu-logo-name.svg" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SeuButton from "/seu-frontend/components/SeuButton";

export default {
  name: "Info",
  components: {SeuButton},
  props: {
    field: {
      type: Object
    }
  },

}
</script>

<style lang="scss">
@import "Info.scss";
</style>
